import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * ボタン
 *【内容:content:string】
 *【表示条件:visible:boolean】
 *【非活性:disabled:boolean】
 *【ボタンタイプ:buttonType:string】
 *【アイコンタイプ:icon:string】
 *【2ndデザイン:secondary:boolean】
 *【ラベル内容:labelContent:string】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-button',
  templateUrl: './button.html',
  styles: [`
    
  `]
})
export class Button extends BaseWidget {
  /**
   * 内容
   */
  @Input() content:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * ボタンタイプ
   */
  @Input() buttonType:string

  /**
   * アイコンタイプ
   */
  @Input() icon:string

  /**
   * 2ndデザイン
   */
  @Input() secondary:boolean

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * デザイン状態を取得する
   *
   */
  get isSecondary() {
    if (!!this.secondary) {
      return true
    } else {
      return
    }
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/button/button.component.ts